var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLupa1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6461 20.5414L16.9828 15.8781C18.0859 14.5312 18.75 12.8109 18.75 10.9375C18.75 6.62969 15.2453 3.125 10.9375 3.125C6.62969 3.125 3.125 6.62969 3.125 10.9375C3.125 15.2453 6.62969 18.75 10.9375 18.75C12.8109 18.75 14.5312 18.0859 15.8781 16.9828L20.5414 21.6461C20.8469 21.9516 21.3406 21.9516 21.6461 21.6461C21.9516 21.3406 21.9516 20.8469 21.6461 20.5414ZM4.6875 10.9375C4.6875 7.49141 7.49141 4.6875 10.9375 4.6875C14.3836 4.6875 17.1875 7.49141 17.1875 10.9375C17.1875 14.3836 14.3836 17.1875 10.9375 17.1875C7.49141 17.1875 4.6875 14.3836 4.6875 10.9375Z",
    fill: "#2D3035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupa1);
export default __webpack_public_path__ + "static/media/lupa 1.14737ce162fd8c46d684119c59b04e80.svg";
export { ForwardRef as ReactComponent };